import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import Media from '../../Media';
import StylableSvg from '../../StylableSvg';
import { classNamesFor } from '../../utils/classNames';
import { Image } from '../../index';
import ResolveTheme from '../../ResolveTheme';

var GameArt = function GameArt(props) {
  var _platformTags$props, _platformTags$props$p;

  var className = props.className,
      qa = props.qa,
      src = props.src,
      alt = props.alt,
      platformTags = props.platformTags,
      disabled = props.disabled,
      cornerRadius = props.cornerRadius,
      interactive = props.interactive;

  var _GameArt$getClassName = GameArt.getClassName({
    className: className,
    disabled: disabled,
    cornerRadius: cornerRadius,
    interactive: interactive
  }),
      root = _GameArt$getClassName.root,
      containerClass = _GameArt$getClassName.container,
      mediaClass = _GameArt$getClassName.media,
      platformClass = _GameArt$getClassName.platform,
      svgClass = _GameArt$getClassName.svg;

  var isPlatformNamesAvailable = (platformTags === null || platformTags === void 0 ? void 0 : (_platformTags$props = platformTags.props) === null || _platformTags$props === void 0 ? void 0 : (_platformTags$props$p = _platformTags$props.platformNames) === null || _platformTags$props$p === void 0 ? void 0 : _platformTags$props$p.length) > 0;
  return /*#__PURE__*/React.createElement("div", {
    "data-qa": qa,
    className: root,
    "aria-hidden": !isPlatformNamesAvailable
  }, /*#__PURE__*/React.createElement("div", {
    className: containerClass,
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(StylableSvg, {
    className: svgClass,
    namespace: "ps-illustration",
    type: "default-product-image"
  }), /*#__PURE__*/React.createElement(Media, {
    alt: alt,
    aspectRatio: "1:1",
    fit: "cover",
    place: "top-left",
    qa: "".concat(qa, "#image"),
    src: src,
    width: "100%",
    className: mediaClass
  }, /*#__PURE__*/React.createElement(ResolveTheme, null, function (_ref) {
    var theme = _ref.theme;
    return /*#__PURE__*/React.createElement(Image, {
      alt: alt,
      aspectRatio: "1:1",
      src: "/fallbacks/default-game-".concat(theme, ".png"),
      useStatic: true
    });
  }))), platformTags && /*#__PURE__*/cloneElement(platformTags, {
    onGraphic: !!src,
    className: platformClass,
    qa: qa
  }));
};

var cx = classNamesFor(GameArt);

GameArt.getClassName = function (_ref2) {
  var className = _ref2.className,
      disabled = _ref2.disabled,
      cornerRadius = _ref2.cornerRadius,
      interactive = _ref2.interactive;
  return {
    root: cx(className, 'psw-game-art', 'psw-fill', 'psw-l-anchor'),
    container: cx('psw-game-art__container', 'psw-l-anchor-top-left', 'psw-l-top-left', 'psw-fill', "psw-r-".concat(cornerRadius), 'psw-clip'),
    media: cx((disabled || interactive) && 'psw-media-interactive', disabled && 'psw-is-disabled'),
    platform: cx('psw-l-anchor-bottom-left', 'psw-l-bottom-left', 'psw-m-l-3', 'psw-m-sub-t-3'),
    svg: cx('default-product-img')
  };
};

GameArt.defaultProps = {
  className: '',
  platformTags: null,
  qa: '',
  cornerRadius: '2',
  disabled: false,
  interactive: true
};
GameArt.propTypes = {
  /**
   * Additional classes to apply to the component, for layout positioning only.
   */
  className: PropTypes.string,

  /**
   * QA automation  id, should identify the component on the page
   */
  qa: PropTypes.string,

  /**
   * The image source
   */
  src: PropTypes.string.isRequired,

  /**
   * Alternative text for screen readers
   */
  alt: PropTypes.string.isRequired,

  /**
   * Platform tags to display alongside the image
   */
  platformTags: PropTypes.element,

  /**
   * Applies desired rounded corners
   */
  cornerRadius: PropTypes.oneOf(['none', '2']),

  /**
   * Whether to apply the disabled presentation
   */
  disabled: PropTypes.bool,
  interactive: PropTypes.bool
};
export default GameArt;